import {SxType} from "@baseTypes/sx/sxTypes";
import {
    FLOATING_SIDEBAR_PANEL_CLASS,
    FLOATING_SIDEBAR_TOGGLE_CLASS,
    GAP_FLOATING_SIDEBAR_PANEL,
    SIZE_FLOATING_SIDEBAR_TOGGLE,
    WIDTH_SIDEBAR_PANEL_DESKTOP
} from "@ui/sidebarPanel/sx";

export const sx: SxType = {
    root: {
        width: '100%',
        height:'100%',
        display:'flex',
        flexDirection:'row',
        justifyContent:'flex-start',
        alignItems:'flex-start',
        overflow:{
            lg:'hidden'
        },
        '&.isLoading':{
            opacity:'.5'
        },
        position: 'relative',
        '@media (min-width: 1200px)': {
            [`&:has(.${FLOATING_SIDEBAR_PANEL_CLASS})`]: {
                '--map-left-offset': `${GAP_FLOATING_SIDEBAR_PANEL + WIDTH_SIDEBAR_PANEL_DESKTOP}px`,
            },
            [`&:has(.${FLOATING_SIDEBAR_TOGGLE_CLASS})`]: {
                '--map-left-offset': `${GAP_FLOATING_SIDEBAR_PANEL + SIZE_FLOATING_SIDEBAR_TOGGLE}px`,
            },
        },
    }
}